// src/automation/components/AutomationAccordionSidebar.js
//
// Sidebar for the Automation console:
//
//   Cover Page                      (always at top; opens the overview)
//   QUEUE STATUS REPORTS            (section header — static label)
//     KYC Inhouse                   (task — single clickable row, opens its page)
//     KYC Concentrix
//     ...
//   RAPID
//     SVR Rapid
//     VAT Rapid
//   FORECAST
//     ...
//
// Tasks are terminal clickable rows (no sub-items). Selecting a task loads its
// full scrollable page in the main area. WBR-themed via shared CSS variables.

import React from "react";
import { LayoutDashboard, ScrollText, Trash2 } from "lucide-react";

export const COVER_KEY = "__cover__";

export default function AutomationAccordionSidebar({
  isOpen = true,
  sections = [],
  activeTaskName,
  coverActive = false,
  onSelectCover,
  onSelectTask,
  // Admins can delete CUSTOM (UI-created) automations from the sidebar.
  canDelete = false,
  onDeleteTask,
  deletingTask = null,
  // Pinned Activity Log entry (admin only).
  showActivity = false,
  activityActive = false,
  onSelectActivity,
}) {
  return (
    <aside className={`auto-acc ${!isOpen ? "auto-acc--closed" : ""}`}>
      <nav className="auto-acc-nav">
        {/* ── Cover Page entry ── */}
        <button
          className={`auto-acc-row auto-acc-row--cover ${
            coverActive ? "auto-acc-row--active" : ""
          }`}
          onClick={onSelectCover}
        >
          <span className="auto-acc-row-icon">
            <LayoutDashboard size={16} />
          </span>
          <span className="auto-acc-row-label">Cover Page</span>
        </button>



        {/* ── Sections ── */}
        {sections.map((section) => (
          <div className="auto-acc-section" key={section.key}>
            <div className="auto-acc-section-title">{section.label}</div>
            {(section.tasks || []).map((task) => {
              const active = task.name === activeTaskName && !coverActive;
              const deletable = canDelete && onDeleteTask;
              return (
                <div key={task.name} className="auto-acc-task-wrap">
                  <button
                    className={`auto-acc-row auto-acc-row--task ${
                      active ? "auto-acc-row--active" : ""
                    } ${deletable ? "auto-acc-row--deletable" : ""}`}
                    onClick={() => onSelectTask(task.name)}
                  >
                    <span className="auto-acc-row-label">{task.label}</span>
                  </button>
                  {deletable && (
                    <button
                      className="auto-acc-del"
                      title={`Delete "${task.label}" and its config`}
                      aria-label={`Delete ${task.label}`}
                      disabled={deletingTask === task.name}
                      onClick={() => onDeleteTask(task.name, task.label)}
                    >
                      <Trash2 size={13} />
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        ))}
      </nav>

      {/* ── Pinned at the bottom: Activity Log (admin) — not an automation ── */}
      {showActivity && (
        <div className="auto-acc-pinned">
          <button
            className={`auto-acc-row auto-acc-row--cover ${activityActive ? "auto-acc-row--active" : ""}`}
            onClick={onSelectActivity}
          >
            <span className="auto-acc-row-icon">
              <ScrollText size={16} />
            </span>
            <span className="auto-acc-row-label">Activity Log</span>
          </button>
        </div>
      )}
    </aside>
  );
}
